/** The address every contact CTA on the site opens against. */
export const CONTACT_EMAIL = "info@sys-it.co.il";

/**
 * Builds a mailto: URL that opens the visitor's mail client (Outlook, Mail,
 * Gmail handler) with the subject pre-filled, so enquiries arrive already
 * labelled with what the visitor clicked.
 *
 * The subject is percent-encoded, which is what makes Hebrew subjects survive
 * the handoff to the mail client.
 */
export const mailtoWithSubject = (subject: string): string =>
    `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}`;
